import React from 'react';
import OrderList from './OrderList/OrderList';
import { useDispatch } from 'react-redux';
import { clearDatahandling } from '../../../utils/clearDataHandling';


const Orders = () => {
  const dispatch = useDispatch()
  React.useEffect(() => {
    clearDatahandling(dispatch)

  }, [])

  return (
    <>

      <div className="Dashboard-page-main">
        <div className="Dashboard-page-wrap">
          <div className="booking-tab-wrap max-720">
            <div className="upcoming-sec">
              <h2>My Orders</h2>

              <OrderList />
            </div>
          </div>
        </div>
      </div>


    </>
  );
};




export default Orders;
